import deepmerge from 'deepmerge'
import i18next, { Resource } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { z } from 'zod'
import { makeZodI18nMap } from 'zod-i18n-map'

import enCommon from './locales/en/common.json'
import enComponent from './locales/en/component.json'
import enDomain from './locales/en/domain.json'
import enValidation from './locales/en/validation.json'
import jaCommon from './locales/ja/common.json'
import type common from './locales/ja/common.json'
import jaComponent from './locales/ja/component.json'
import type component from './locales/ja/component.json'
import jaDomain from './locales/ja/domain.json'
import type domain from './locales/ja/domain.json'
import jaValidation from './locales/ja/validation.json'
import type validation from './locales/ja/validation.json'

export interface I18nNamespaces {
  common: typeof common
  component: typeof component
  domain: typeof domain
  validation: typeof validation
}

const commonResources: Resource = {
  en: {
    common: enCommon,
    component: enComponent,
    domain: enDomain,
    validation: enValidation,
  },
  ja: {
    common: jaCommon,
    component: jaComponent,
    domain: jaDomain,
    validation: jaValidation,
  },
}

const detection = {
  order: ['cookie', 'localStorage', 'navigator'],
  caches: ['localStorage', 'cookie'],
}

type Props = {
  resources: Resource
  debug?: boolean
}

export function initI18n({ resources, debug = false }: Props): typeof i18next {
  const _resources = deepmerge(commonResources, resources)

  void i18next
    // .use(I18nextBrowserLanguageDetector) // i18n 対応完了まで ja のみ表示にする
    .use(initReactI18next)
    .init({
      resources: _resources,
      detection,
      fallbackLng: 'ja',
      ns: Object.keys(_resources).map((key) => key),
      defaultNS: 'common',
      debug,
      interpolation: {
        escapeValue: false,
      },
    })

  z.setErrorMap(makeZodI18nMap({ t: i18next.t, ns: ['validation'] }))
  return i18next
}
